import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Select } from '@/elements';
import './index.scss';

const EvacuationSitesSelect = ({ sitesList, ...rest }) => (
	<Fragment>
		{!!sitesList.length && (
			<Select {...rest} className="evacuation-sites-select">
				{sitesList.map((site, index) => (
					<Select.Option key={index} value={site.siteId}>
						{`${site.description}, ${site.address}`}
					</Select.Option>
				))}
			</Select>
		)}
	</Fragment>
);

EvacuationSitesSelect.defaultProps = {
	sitesList: [],
};

EvacuationSitesSelect.propTypes = {
	sitesList: PropTypes.array.isRequired,
};

export default EvacuationSitesSelect;



// WEBPACK FOOTER //
// ./src/pages/evacuation-demo/components/evacuation-sites-select/index.js